/**
 * The bounding box of a GeoJSON geometry, in GeoJSON order: [[minLon, minLat], [maxLon, maxLat]].
 *
 * Its own module, free of turf, because everything that needs a box — the map frame, the parcel
 * query — would otherwise drag a geometry library along for four comparisons.
 */

const isPointPair = (value: any): boolean =>
    Array.isArray(value) && value.length >= 2 && typeof value[0] === 'number' && typeof value[1] === 'number';

export const geometryBounds = (geometry: any): [[number, number], [number, number]] | null => {
    const coordinates: number[][] = [];
    const walk = (node: any): void => {
        if (!Array.isArray(node)) return;
        if (isPointPair(node)) {
            coordinates.push(node);
            return;
        }
        node.forEach(walk);
    };
    walk(geometry?.coordinates);

    if (coordinates.length === 0) return null;

    const lons = coordinates.map(([lon]) => lon);
    const lats = coordinates.map(([, lat]) => lat);
    return [
        [Math.min(...lons), Math.min(...lats)],
        [Math.max(...lons), Math.max(...lats)],
    ];
};
